import ContentPaste from "@mui/icons-material/ContentPaste";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

interface TProps {
    value: string | number;
    color: string;
    style: any;
}

const CopyToClipboardButton = (props: TProps) => {
    const [t] = useTranslation();

    const handleClick = () => {
        toast.success(`${t("Management.CopiedToClipboard")}`);
        navigator.clipboard.writeText(props.value.toString());
    };

    return (
        <>
            <IconButton onClick={handleClick} style={{ color: props.color || "#000", ...props.style }}>
                <ContentPaste style={props.style} />
            </IconButton>
        </>
    );
};

export default CopyToClipboardButton;
